import axios, { Canceler } from 'axios';
import { action, computed, makeObservable, observable } from 'mobx';
import { IPreviousOrderModal } from '../types/previousOrderModal';
import { modalStore } from 'src/mobx/modalStore';
import client from 'src/services/client';
import { ICurrencySettings } from 'src/types/branches';
import { TOrder } from 'src/types/orders';
import { getCancelToken } from 'src/utils/helpers';
import logger from '~/services/logger';

class PreviousOrderModalStore {
  constructor() {
    makeObservable(this);
  }

  private cancel: Canceler | null = null;

  private orderId: number | null = null;

  @observable public loading: boolean = false;
  @observable public order: TOrder | null = null;

  @computed public get currencySettings(): ICurrencySettings {
    return {
      currency_code: this.order?.currency?.currency_code,
      currency_position: this.order?.currency?.currency_position,
      currency_divided: this.order?.currency?.divided,
    };
  }

  public init = (props: IPreviousOrderModal) => {
    this.orderId = props.id;

    this.fetchOrder();
  };

  @action private fetchOrder = async () => {
    try {
      if (!this.orderId) return;

      if (this.cancel) this.cancel('Cancelled');
      this.loading = true;

      const response: TOrder = await client.get(`/v3/orders/${this.orderId}/details`, {
        params: { is_current_products: 1 },
        cancelToken: getCancelToken((c) => (this.cancel = c)),
      });

      this.order = response;
      this.loading = false;
    } catch (error: any) {
      if (axios.isCancel(error)) return;
      this.loading = false;
      logger.error({ error, place: 'PreviousOrderModalStore fetchOrder', showModal: true });
    }
  };

  public closeModal = () => {
    modalStore.closePreviousOrderModal();
    this.clearStore();
  };

  private clearStore = () => {
    this.loading = false;
    this.order = null;
    if (this.cancel) this.cancel('Cancelled');
  };
}

export const previousOrderModalStore = new PreviousOrderModalStore();
